import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "../Hooks";
import { getGroups } from "../../requests/groupManagementRequests";
import { PageWrapper } from "../UI/Grid";
import Table from "../UI/Table";
import { Body } from "../UI/Text";

const GroupsPage = () => {
  const navigate = useNavigate();
  const { pid } = useParams();

  const { data, isLoading, refetchQuery } = useQuery({
    queryID: "groups",
    request: getGroups,
    queryVariables: { pid },
    forcedFilters: {},
    skip: !pid,
  });

  const { rows = [], count } = data || {};

  const columns = useMemo(
    (rows) => [
      {
        id: "id",
        data: ({ id }) => <Body ellipsis>{id}</Body>,
        header: "Group ID",
        sort: true,
        size: { md: 2, sm: -1, xs: -1 },
      },
      {
        id: "name",
        data: ({ name }) => <Body ellipsis>{name}</Body>,
        header: "Name",
        sort: true,
        size: { md: 3, sm: 3, xs: 5 },
      },     
      
    ],
    [getGroups, data, ]
  );

  const onCardClick = (id) => {
    navigate(`/Group/${id}`);
  };

  const getIcon = (pid) => {
    switch (pid) {
      case 9:
        return "faUserAstronaut";
      case 5:
        return "faUserTie";
      case 1:
        return "faUserCheck";
      default:
        return "faPeopleGroup";
    }
  };

  const gridData = useMemo(() => {
    if (!rows) return null;
    return rows.map(({ id, name, description, pid }) => ({
      key: id,
      id,
      title: name,
      subtitle: description,
      iconName: getIcon(pid),
    }));
  }, [rows]);

  return (
    <>
     {/* <Table
        createButtonText="Create User"
        createButtonIcon="faUserPlus"
        createLink="/Users/create"
        title="Users"
        subtitle={subtitle}
        data={rows}
        columns={columns}
        refetchData={refetchQuery}
        hideRefetch={false}
        onRowClick={onRowClick}
        onCardClick={onRowClick}
        gridData={gridData}
        backButtonLink="/Administration"
        // selections={selections}
        isLoading={isLoading}
        totalCount={count}
      /> */}
      <PageWrapper>
        <Table
          createLink={() => navigate("/Group/create")}
          createButtonText="Create Group"
          createButtonIcon="faUserGroup"
          title="Group Management"
          backButtonLink="/Administration"
          gridData={gridData}
          refetchData={refetchQuery}
          hideRefetch={false}
          isLoading={isLoading}
          columns={columns}
          data={rows}
          hideToggle
          hideProperties
          hidePager
          hideSearch
          forceGrid
          onCardClick={(group) => onCardClick(group.id)}
          onRowClick={(group) => onCardClick(group.id)}
          totalCount={count}          
        />
      </PageWrapper>
    </>
  );
};

export default GroupsPage;
